import { render, staticRenderFns } from "./DiscountProgram.vue?vue&type=template&id=084c3ffe&scoped=true"
import script from "./DiscountProgram.vue?vue&type=script&lang=js"
export * from "./DiscountProgram.vue?vue&type=script&lang=js"
import style0 from "./DiscountProgram.vue?vue&type=style&index=0&id=084c3ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084c3ffe",
  null
  
)

export default component.exports